import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  CRUDLayout,
  InputSearch,
  CreateButton,
  DeleteButton,
  UpdateButton,
  ActionButton,
  DataStatus,
  CreateModal,
  UpdateModal,
  DeleteModal,
  Alert,
  Input,
  Pagination,
  TextArea,
  Switch,
  Select,
  THead,
  TBody,
  ThFixed,
  TdFixed,
  Tr,
  Th,
  Td,
} from '../../../../components';
import { PangkatApi } from '../../../../api';
import { TableNumber } from '../../../../utilities';
import { useIsGuest } from 'hooks';
import { ErrorAlert } from './comps';

const Pangkat = ({ setNavbarTitle }) => {
  // Title
  const title = 'Pangkat';
  const guest = useIsGuest();

  // indikator pemanggilan data sedang dimuat di server
  const [isPageLoading, setIsPageLoading] = useState(true);

  // indikator apakah sedang melakukan searching
  const [isSearching, setIsSearching] = useState(false);

  // menampung value dari search form
  const [searchKey, setSearchKey] = useState('');

  // menangani modal form tambah
  const [isCreateForm, setIsCreateForm] = useState(false);
  // menangani modal form ubah
  const [isUpdateform, setIsUpdateform] = useState(false);
  // menangani modal hapus data
  const [isDeleteData, setIsDeleteData] = useState(false);

  // data jenis anggaran
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [dataLength, setDataLength] = useState(10);
  const [dataCount, setDataCount] = useState(0);

  // menampung data yang akan diubah
  const [updateData, setUpdateData] = useState([]);
  // menampung data yang akan dihapus
  const [deleteData, setDeleteData] = useState([]);

  // menampilkan alert
  const [showAlert, setShowAlert] = useState(false);
  // configurasi alert
  const [alertConfig, setAlertConfig] = useState({
    variant: 'primary',
    text: '',
    searchKey: '',
  });

  // request data dari server
  const getData = () => {
    setIsPageLoading(true);

    setIsSearching(false);

    // request data ke server
    PangkatApi.getPage(page, dataLength, searchKey)
      .then((res) => {
        setData(res.data.data);
        setTotalPage(res.data.total_page);
        setDataCount(res.data.data_count);
      })
      .catch(() =>
        setAlertConfig({
          show: true,
          variant: 'danger',
          text: 'Data gagal dimuat!',
        })
      )
      .finally(() => {
        setIsPageLoading(false);
      });
  };

  // menangani hide/show data
  const changeDataStatus = (status, id) => {
    setIsPageLoading(true);
    setShowAlert(false);

    const value = {
      id_pangkat: id,
    };

    const onLoadedSuccess = () => {
      setIsSearching(false);
      setAlertConfig({
        variant: 'primary',
        text: 'Ubah status data berhasil',
      });
      setShowAlert(true);
    };

    const onLoadedFailed = () => {
      setIsSearching(false);
      setAlertConfig({
        variant: 'danger',
        text: 'Ubah status data gagal',
      });
      setShowAlert(true);
    };

    status === true
      ? PangkatApi.show(value)
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData())
      : PangkatApi.hide(value)
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData());
  };

  // request search data dari server
  const searchData = (e) => {
    // mencegah terjadinya page reload
    e.preventDefault();

    // set loading
    setIsPageLoading(true);

    // nilai dari form search
    const key = searchKey;

    PangkatApi.search(key)
      .then((res) => {
        setData(res.data.data);
        setTotalPage(res.data.total_page);
        setAlertConfig({
          variant: 'primary',
          searchKey: key,
        });
      })
      .catch(() => {
        setAlertConfig({
          variant: 'danger',
          text: 'Gagal untuk memuat data',
        });
      })
      .finally(() => {
        setPage(1);
        setIsSearching(true);
        setIsPageLoading(false);
        setShowAlert(true);
      });
  };

  useEffect(() => {
    // set judul di Navbar
    setNavbarTitle(title);

    // jalankan function request data ke server
    getData();

    // menangani pembersihan saat fetching data
    return () => {
      setIsPageLoading(false);
    };
  }, [setNavbarTitle, page, dataLength, searchKey]);

  // modal tambah
  const TambahModal = () => {
    const [duplicate, setDuplicate] = useState({
      show: false,
      text: '',
    });
    // nilai awal form
    const formInitialValues = {
      jenis_pangkat: '',
      nama_pangkat: '',
      keterangan: '',
    };

    // skema validasi form
    const formValidationSchema = Yup.object().shape({
      jenis_pangkat: Yup.string().required('Pilih jenis pangkat'),
      nama_pangkat: Yup.string().required('Masukan nama pangkat'),
    });

    // request tambah data ke server
    const formSubmitHandler = (values, { setSubmitting }) => {
      PangkatApi.create(values)
        .then(() => {
          // konfigurasi alert
          setAlertConfig({
            show: true,
            variant: 'primary',
            text: 'Tambah data berhasil!',
          });
          setIsCreateForm(false);
          setShowAlert(true);
          setDuplicate({ show: false });
          getData();
        })
        .catch((err) => {
          // konfigurasi alert
          // setAlertConfig({
          //   show: true,
          //   variant: "danger",
          //   text: `Tambah data gagal!`,
          // });
          // setIsCreateForm(true);
          setDuplicate({
            show: true,
            text: `${err?.response?.data?.message}`,
          });
          setSubmitting(false);
        });
      // .finally(() => {
      // menutup modal
      // setIsCreateForm(false);
      // menampilkan alert
      // setShowAlert(true);
      // request data baru ke server
      // getData();
      // });
    };

    return (
      <CreateModal
        show={isCreateForm}
        onHide={() => setIsCreateForm(false)}
        title={title}
      >
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                {duplicate?.show ? (
                  <ErrorAlert textError={duplicate?.text} />
                ) : (
                  ''
                )}
                <Select
                  label="Jenis Pangkat"
                  placeholder="Masukan jenis pangkat"
                  name="jenis_pangkat"
                  defaultValue={values.jenis_pangkat}
                  error={errors.jenis_pangkat && touched.jenis_pangkat && true}
                  errorText={errors.jenis_pangkat}
                  onChange={handleChange}
                >
                  <option value="">Pilih jenis pangkat</option>
                  <option value="FN">Fungsional</option>
                  <option value="ST">Struktural</option>
                </Select>
                <Input
                  label="Nama Pangkat"
                  placeholder="Masukan nama pangkat"
                  name="nama_pangkat"
                  value={values.nama_pangkat}
                  error={errors.nama_pangkat && touched.nama_pangkat && true}
                  errorText={errors.nama_pangkat}
                  onChange={handleChange}
                />
                <TextArea
                  label="Keterangan"
                  placeholder="Masukan keterangan"
                  name="keterangan"
                  value={values.keterangan}
                  error={errors.keterangan && touched.keterangan && true}
                  errorText={errors.keterangan}
                  onChange={handleChange}
                />
              </Modal.Body>
              <Modal.Footer>
                <ActionButton
                  type="submit"
                  variant="primary"
                  text="Tambah Data"
                  loading={isSubmitting}
                />
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </CreateModal>
    );
  };

  // modal ubah
  const UbahModal = () => {
    const [duplicate, setDuplicate] = useState({
      show: false,
      text: '',
    });
    // nilai awal form
    const formInitialValues = {
      jenis_pangkat: updateData.jenis_pangkat,
      nama_pangkat: updateData.nama_pangkat,
      keterangan: updateData.keterangan,
    };

    // skema validasi form
    const formValidationSchema = Yup.object().shape({
      jenis_pangkat: Yup.string().required('Pilih jenis pangkat'),
      nama_pangkat: Yup.string().required('Masukan nama pangkat'),
    });

    // request ubah data ke server
    const formSubmitHandler = (values, { setSubmitting }) => {
      const convertJenisPangkat = (jenis) => {
        const parse = jenis.toUpperCase();

        return jenis === 'STRUKTURAL' ? 'ST' : 'FN';
      };

      const finalValues = {
        ...values,
        id_pangkat: updateData.id_pangkat,
        jenis_pangkat: convertJenisPangkat(values.jenis_pangkat),
      };

      PangkatApi.update(finalValues)
        .then(() => {
          // konfigurasi alert
          setAlertConfig({
            show: true,
            variant: 'primary',
            text: 'Ubah data berhasil!',
          });
          setIsUpdateform(false);
          setShowAlert(true);
          setDuplicate({ show: false });
          getData();
        })
        .catch((err) => {
          // konfigurasi alert
          // setAlertConfig({
          //   show: true,
          //   variant: "danger",
          //   text: `Ubah data gagal! (${err})`,
          // });
          // setIsUpdateform(true);
          setDuplicate({
            show: true,
            text: `${err?.response?.data?.message}`,
          });
          setSubmitting(false);
        });
      // .finally(() => {
      // menutup modal
      // setIsUpdateform(false);
      // menampilkan alert
      // setShowAlert(true);
      // request data baru ke server
      // getData();
      // });
    };

    return (
      <UpdateModal
        show={isUpdateform}
        onHide={() => setIsUpdateform(false)}
        title={title}
      >
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                {duplicate?.show ? (
                  <ErrorAlert textError={duplicate?.text} />
                ) : (
                  ''
                )}
                <Select
                  label="Jenis Pangkat"
                  placeholder="Masukan jenis pangkat"
                  name="jenis_pangkat"
                  defaultValue={values.jenis_pangkat.toUpperCase()}
                  error={errors.jenis_pangkat && touched.jenis_pangkat && true}
                  errorText={errors.jenis_pangkat}
                  onChange={handleChange}
                >
                  <option value="">Pilih jenis pangkat</option>
                  <option value="FUNGSIONAL">Fungsional</option>
                  <option value="STRUKTURAL">Struktural</option>
                </Select>
                <Input
                  label="Nama Pangkat"
                  placeholder="Masukan nama pangkat"
                  name="nama_pangkat"
                  value={values.nama_pangkat}
                  error={errors.nama_pangkat && touched.nama_pangkat && true}
                  errorText={errors.nama_pangkat}
                  onChange={handleChange}
                />
                <TextArea
                  label="Keterangan"
                  placeholder="Masukan keterangan"
                  name="keterangan"
                  value={values.keterangan}
                  error={errors.keterangan && touched.keterangan && true}
                  errorText={errors.keterangan}
                  onChange={handleChange}
                />
              </Modal.Body>
              <Modal.Footer>
                <ActionButton
                  type="submit"
                  variant="success"
                  text="Ubah Data"
                  loading={isSubmitting}
                />
              </Modal.Footer>
            </form>
          )}
        </Formik>
      </UpdateModal>
    );
  };

  // modal hapus
  const HapusModal = () => {
    // set id dari data yang ingin dihapus
    const idData = deleteData.id_pangkat;
    const values = { id_pangkat: idData };

    // menangani delete button loading
    const [btnLoading, setBtnLoading] = useState(false);

    // menangani pembersihan saat fetching data
    useEffect(() => {
      return () => {
        setBtnLoading(false);
      };
    }, []);

    // request hapus data ke server
    const deleteDataHandler = () => {
      // set delete button loading
      setBtnLoading(true);

      PangkatApi.delete(values)
        .then(() => {
          // konfigurasi alert
          setAlertConfig({
            show: true,
            variant: 'primary',
            text: 'Hapus data berhasil!',
          });
        })
        .catch((err) => {
          // konfigurasi alert
          setAlertConfig({
            show: true,
            variant: 'danger',
            text: `Hapus data gagal! (${err})`,
          });
        })
        .finally(() => {
          // menutup modal
          setIsDeleteData(false);
          // menampilkan alert
          setShowAlert(true);
          // request data baru ke server
          getData();
        });
    };

    return (
      <DeleteModal
        show={isDeleteData}
        onHide={() => setIsDeleteData(false)}
        loading={btnLoading}
        onConfirm={deleteDataHandler}
        title={title}
      >
        <span>Nama Pangkat : {deleteData.nama_pangkat}</span>
      </DeleteModal>
    );
  };

  // Tabel
  const Table = () => (
    <>
      <CRUDLayout.Table>
        <THead>
          <Tr>
            <ThFixed>No</ThFixed>
            {guest ? '' : <ThFixed>Aksi</ThFixed>}
            <ThFixed>Jenis Pangkat</ThFixed>
            <Th>Nama Pangkat</Th>
            <Th>Keterangan</Th>
          </Tr>
        </THead>
        <TBody>
          {data.map((val, index) => (
            <Tr key={index}>
              <TdFixed>{TableNumber(page, dataLength, index)}</TdFixed>
              {guest ? (
                ''
              ) : (
                <TdFixed>
                  <div className="d-flex justify-content-center">
                    <UpdateButton
                      onClick={() => {
                        setUpdateData(val);
                        setIsUpdateform(true);
                      }}
                    />
                    <DeleteButton
                      onClick={() => {
                        setDeleteData(val);
                        setIsDeleteData(true);
                      }}
                    />
                    <Switch
                      id={toString(index + 1)}
                      checked={!val.is_hidden}
                      onChange={() =>
                        changeDataStatus(val.is_hidden, val.id_pangkat)
                      }
                    />
                  </div>
                </TdFixed>
              )}
              <TdFixed>{val.jenis_pangkat}</TdFixed>
              <Td>{val.nama_pangkat}</Td>
              <Td>{val.keterangan}</Td>
            </Tr>
          ))}
        </TBody>
      </CRUDLayout.Table>
      {!isSearching && (
        <Pagination
          dataLength={dataLength}
          dataNumber={page * dataLength - dataLength + 1}
          dataPage={dataCount < dataLength ? dataCount : page * dataLength}
          dataCount={dataCount}
          onDataLengthChange={(e) => {
            setDataLength(e.target.value);
            setPage(1);
          }}
          currentPage={page}
          totalPage={totalPage}
          onPaginationChange={({ selected }) => setPage(selected + 1)}
        />
      )}
    </>
  );

  return (
    <CRUDLayout>
      {/* head */}
      <CRUDLayout.Head>
        {/* search section */}
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch
              onChange={(e) => {
                const key = e.target.value;
                setSearchKey(key);
                setAlertConfig({
                  show: key ? true : false,
                  variant: 'primary',
                  text: 'Hasil dari pencarian: ' + key,
                });
              }}
            />
          </div>
        </CRUDLayout.HeadSearchSection>

        {/* button section */}
        <CRUDLayout.HeadButtonSection>
          <CreateButton onClick={() => setIsCreateForm(true)} />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* aLert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
      />

      {/* table section */}
      {
        // cek apakah data sedang dimuat (loading)
        isPageLoading === true ? (
          // loading
          <DataStatus loading={true} text="Memuat data..." />
        ) : // Cek apakah ada data
        data.length > 0 ? (
          // Ada data
          <Table />
        ) : (
          // Tidak ada data
          <DataStatus text="Tidak ada data" />
        )
      }

      {/* Modal */}
      <TambahModal />
      <UbahModal />
      <HapusModal />
    </CRUDLayout>
  );
};

export default Pangkat;
